import { BlurView } from 'expo-blur'
import React from 'react'
import { Image, StyleSheet, View } from 'react-native'

import { useRouter } from 'expo-router'

import { DS } from '../../../design-system'
import { useStore } from '../../../models'
import { events } from '../../../models/analytics/analytics-events'
import Radial from '../assets/radial.svg'

export const JoinPremiumCard = () => {
  const router = useRouter()

  const {
    session: { user },
    analytics: { setEvent }
  } = useStore()
  const userId = user?._id.toString()

  const navigateToPremiumAndTrack = () => {
    setEvent(events.homescreen.CTA_go_premium_tapped, {
      userId: userId,
      from_screen: 'Home Tab'
    })
    router.navigate('/(root)/(tabs)/membership')
  }
  return (
    <BlurView intensity={80} tint="light" style={styles.container}>
      <Image source={require('../assets/join-premium.png')} style={styles.headerImage} />
      <DS.Frame gap="8" bg="Global/White" style={styles.frameContainer}>
        <DS.Text variant="Heading 3/Medium">Join Premium</DS.Text>
        <DS.Text variant="Body Medium/Regular">Unlock access to our brand new features.</DS.Text>
        <DS.Frame row gap="4" bg="Brand/Cream" style={{ marginTop: 10, borderRadius: 8, padding: 8 }}>
          <Image source={require('../assets/orange-tick.png')} style={{ width: 24, height: 24 }} />
          <DS.Text variant="Body Medium/Regular">40+ On-Demand Video Lessons</DS.Text>
        </DS.Frame>
        <DS.Frame row gap="4" bg="Brand/Cream" style={{ borderRadius: 8, padding: 8 }}>
          <Image source={require('../assets/orange-tick.png')} style={{ width: 24, height: 24 }} />
          <DS.Text variant="Body Medium/Regular">Exclusive Community Access</DS.Text>
        </DS.Frame>
        <DS.Button
          variant={'Large/Primary'}
          type={'On Light'}
          onPress={navigateToPremiumAndTrack}
          style={styles.getStartedButton}
          leftIcon={<Image source={require('../assets/white-crown.png')} style={{ width: 20, height: 20 }} />}
        >
          Get Started
        </DS.Button>
        <View style={styles.radialStyle}>
          <Radial />
        </View>
      </DS.Frame>
    </BlurView>
  )
}

const styles = StyleSheet.create({
  container: {
    padding: DS.spacing[16],
    backgroundColor: 'rgba(255, 255, 255, 0.50)',
    borderRadius: 12,
    overflow: 'hidden'
  },
  frameContainer: {
    padding: DS.spacing[16],
    borderBottomLeftRadius: 12,
    borderBottomRightRadius: 12,
    overflow: 'hidden'
  },
  getStartedButton: {
    marginTop: 8,
    width: '50%'
  },
  headerImage: {
    alignSelf: 'center',
    width: '100%',
    height: 48,
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12
  },
  radialStyle: {
    alignItems: 'flex-end',
    position: 'absolute',
    bottom: 0,
    right: 0
  }
})
